import { Button, Modal } from "antd";
import React from "react";
import { svg } from "../../../../Assets/svg";
import { formatCurrency, formatToLocalDate } from "../../../../helpers/utils";

interface Props {
  open: boolean;
  onClose: () => void;
  milestoneData?: any;
  onEdit: () => void;
}

const ViewPaidMilestoneDetails: React.FC<Props> = ({
  open,
  onClose,
  milestoneData,
  onEdit,
}) => {
  console.log(milestoneData, "milestoneDatamilestoneDatamilestoneData");
  // Safe access to data

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      title={
        <div className="text-center fs-4 fw-bolder lh-m mb-4">
          {/* ✅ Corrected Title: Shows % for percentage, £ for fixed */}
          Payment Details
        </div>
      }
      closeIcon={svg?.closeIcon}
      width={"33.75rem"}
      className="commonModalClass"
    >
      <div className="row gy-md-4 gy-3">
        <div className="col-lg-6">
          <label className="fs-6 fw-normal text-secondary d-block mb-1">
            Amount
          </label>
          <span className="fw-semibold text-dark fs-6">
            {/* Show 0.00 if amount_paid is missing */}
            {milestoneData?.amount_paid
              ? formatCurrency(milestoneData?.amount_paid, milestoneData?.currency || "GBP")
              : "0.00"}
          </span>
        </div>
        <div className="col-lg-6">
          <label className="fs-6 fw-normal text-secondary d-block mb-1">
            Payment Date
          </label>
          <span className="fw-semibold text-dark fs-6">
            {milestoneData?.payment_date
              ? formatToLocalDate(milestoneData?.payment_date)
              : "-"}
          </span>
        </div>
        <div className="col-lg-12">
          <label className="fs-6 fw-normal text-secondary d-block mb-1">
            Payment Notes
          </label>
          <span className="fw-semibold text-dark fs-6 text-break">
            {milestoneData?.payment_notes || "-"}
          </span>
        </div>
        <div className="col-12 mt-4">
          <div className="row justify-content-center gx-3">
            <div className="col-6">
              <Button
                className="btn btn-lg btn-outline-secondary w-100 h-auto"
                onClick={onClose}
              >
                CLOSE
              </Button>
            </div>
            <div className="col-6">
              <Button
                htmlType="submit"
                className="btn btn-lg btn-primary w-100 h-auto"
                onClick={() => {
                  onEdit();
                }}
              >
                UPDATE
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ViewPaidMilestoneDetails;
